var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8V5C15 2.79086 13.2091 1 11 1C8.79086 1 7 2.79086 7 5V8H15ZM6 5V8H2V21H20V8H16V5C16 2.23858 13.7614 0 11 0C8.23858 0 6 2.23858 6 5ZM3 9H6H16H19V20H3V9ZM12.5 14.5C12.5 15.3284 11.8284 16 11 16C10.1716 16 9.5 15.3284 9.5 14.5C9.5 13.6716 10.1716 13 11 13C11.8284 13 12.5 13.6716 12.5 14.5ZM13.5 14.5C13.5 15.8807 12.3807 17 11 17C9.61929 17 8.5 15.8807 8.5 14.5C8.5 13.1193 9.61929 12 11 12C12.3807 12 13.5 13.1193 13.5 14.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.7fc2291d1d03f0d043ba94746b7f801e.svg";
export { ForwardRef as ReactComponent };